import $ from "jquery"

// 适配UI
export function adaptUI() {
  // 获取元素距离顶部的距离跟可视区域的高度
  const h = screen.height
  const w = screen.width
  console.log(h)
  // alert(h)

  if (w <= 500) {
    $(".title").css({"margin-top": ((h / 100) * 1.5) + 100 + "px", "width": "70%","margin-left":"-10%"})
    if (h >= 700 && h <= 800) {
      $(".bgs").css({"height": "85vh", "margin-top": "13%"})
      $(".title").css({"margin-top": ((h / 100) * 1.5) + 100 + "px"})
    } else if (h >= 800 && h <= 900) {
      $(".options_a").css({"margin-top": "7%"})
      $(".options_b").css({"margin-top": "7%"})
      $(".options_c").css({"margin-top": "7%"})
      $(".bgs").css({"height": "85vh", "margin-top": "13%"})
      $(".title").css({"margin-top": ((h / 100) * 1.5) + 100 + "px"})
    } else {
      $(".title").css({"margin-top": ((h / 100) * 1.5) + 50 + "px"})
    }
  } else {
    if (h >= 900 && h <= 1000) {
      $(".title").css({"margin-top": ((h / 100) * 1.5) + 100 + "px", "width": "50%","left": "25%"})
      $(".options_a").css({"width": "50%", "margin-left": "25%"})
      $(".options_b").css({"width": "50%", "margin-left": "25%"})
      $(".options_c").css({"width": "50%", "margin-left": "25%"})
      $(".tips").css({"width": "50%", "margin-left": "10%"})
      $(".btn").css({"margin-left": "25%"})
      $(".btn1").css({"margin-right": "25%"})
      $(".bgs").css({"height": "86%", "margin-top": "7%", "width": "80%", "left": "10%"})
    } else if (h >= 1000 && h <= 1100) {
      $(".title").css({"margin-top": ((h / 100) * 1.5) + 120 + "px", "width": "50%", "left": "25%"})
      $(".options_a").css({"width": "50%", "margin-left": "25%"})
      $(".options_b").css({"width": "50%", "margin-left": "25%"})
      $(".options_c").css({"width": "50%", "margin-left": "25%"})
      $(".tips").css({"width": "50%", "margin-left": "10%"})
      $(".btn").css({"margin-left": "25%"})
      $(".btn1").css({"margin-right": "25%"})
      $(".bgs").css({"height": "86%", "margin-top": "7%", "width": "80%", "left": "10%"})
    } else if (h >= 1100) {
      $(".title").css({"margin-top": ((h / 100) * 1.5) + 150 + "px", "width": "50%", "left": "25%"})
      $(".options_a").css({"width": "50%", "margin-left": "25%"})
      $(".options_b").css({"width": "50%", "margin-left": "25%"})
      $(".options_c").css({"width": "50%", "margin-left": "25%"})
      $(".tips").css({"width": "50%", "margin-left": "10%"})
      $(".btn").css({"margin-left": "25%"})
      $(".btn1").css({"margin-right": "25%"})
      $(".bgs").css({"height": "80%", "margin-top": "10%", "width": "80%", "left": "10%"})
    }
  }

}

export default {
  adaptUI
}





// WEBPACK FOOTER //
// ./src/components/utils/util.js